/* ============================================================
   WOOMN — Mobile product-card image gallery swipe.
   Swipe LEFT/RIGHT on a product card photo to cycle through
   the product's images (up to 5), with dot indicators.
   Touch devices only — desktop keeps the hover effect.
   ============================================================ */
(function () {
  'use strict';

  var isTouch = window.matchMedia('(hover: none)').matches;
  if (!isTouch) return;

  var THRESHOLD = 30;   /* min horizontal px to count as a swipe */
  var DOMINANCE = 1.2;  /* horizontal must exceed vertical * this */

  function setup(pic) {
    if (pic.dataset.wmnGalleryBound === '1') return;
    var extras = pic.querySelectorAll('.wmn-card-extra');
    if (!extras.length) return;
    var main = pic.querySelector('.card__img:not(.card__img--hover)');
    if (!main) return;
    pic.dataset.wmnGalleryBound = '1';

    var slides = [main];
    for (var i = 0; i < extras.length; i++) slides.push(extras[i]);
    var total = slides.length;
    var current = 0;

    /* dots */
    var dotsWrap = pic.querySelector('.wmn-card-dots');
    var dots = [];
    if (dotsWrap) {
      dotsWrap.innerHTML = '';
      for (var d = 0; d < total; d++) {
        var dot = document.createElement('span');
        dot.className = 'wmn-card-dot' + (d === 0 ? ' is-active' : '');
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function render() {
      for (var i = 0; i < total; i++) {
        slides[i].style.transform = 'translateX(' + ((i - current) * 101) + '%)';
      }
      for (var d = 0; d < dots.length; d++) {
        dots[d].classList.toggle('is-active', d === current);
      }
    }
    render();

    var sx = 0;
    var sy = 0;
    var lx = 0;
    var ly = 0;
    var tracking = false;

    /* keep the parent section carousel (swiper) from hijacking
       touches that start on the product photo */
    pic.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') e.stopPropagation();
    });
    pic.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') e.stopPropagation();
    });

    pic.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      sx = lx = t.clientX;
      sy = ly = t.clientY;
      tracking = true;
      e.stopPropagation();
    }, { passive: true });

    pic.addEventListener('touchmove', function (e) {
      if (!tracking) return;
      var t = e.touches[0];
      lx = t.clientX;
      ly = t.clientY;
      e.stopPropagation();
    }, { passive: true });

    pic.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var dx = lx - sx;
      var dy = ly - sy;
      if (Math.abs(dx) < THRESHOLD) return;
      if (Math.abs(dx) < Math.abs(dy) * DOMINANCE) return;
      e.stopPropagation();
      if (dx < 0) {
        current = (current + 1) % total;
      } else {
        current = (current - 1 + total) % total;
      }
      render();
      suppressNextClick(pic);
    }, { passive: true });
  }

  /* stop the swipe from also opening the product page */
  function suppressNextClick(el) {
    var handler = function (e) {
      e.preventDefault();
      e.stopPropagation();
      el.removeEventListener('click', handler, true);
    };
    el.addEventListener('click', handler, true);
    setTimeout(function () {
      el.removeEventListener('click', handler, true);
    }, 500);
  }

  function initAll(root) {
    var pics = (root || document).querySelectorAll('.card__picture');
    for (var i = 0; i < pics.length; i++) setup(pics[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  window.addEventListener('load', function () { initAll(); });
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target || document);
  });
})();
